import { List } from 'immutable';
import RecipeStep, { RecipeSteps } from 'records/RecipeStep';
import BaseList from 'records/BaseList';

import {
  RECIPE_STEPS_ASYNC_ACTION_START,
  RECIPE_STEPS_ASYNC_ACTION_ERROR,
  RECIPE_STEPS_ASYNC_UPDATE_ACTION_SUCCESS,
  RECIPE_STEPS_OPTIONS_UPDATE,
  RECIPE_STEPS_DRAGGABLE_UPDATE,
  RECIPE_STEPS_UPDATE_ORDINAL_SUCCESS,
  RECIPE_STEPS_RESET_STATE,
} from 'actions/recipeSteps';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [RECIPE_STEPS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [RECIPE_STEPS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [RECIPE_STEPS_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    let newRecipeSteps = RecipeSteps(action.data);
    newRecipeSteps = RecipeStep.sortRecipeStepByOrdinal(newRecipeSteps);
    return new BaseList({
      loading: false,
      errorMessage: null,
      data: newRecipeSteps,
    });
  },
  [RECIPE_STEPS_DRAGGABLE_UPDATE]: (state, action) => {
    let newRecipeSteps = RecipeStep.updateRecipeStepOrdinalsFromIndex(action.data);
    newRecipeSteps = RecipeStep.sortRecipeStepByOrdinal(newRecipeSteps);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newRecipeSteps,
    });
  },
  [RECIPE_STEPS_UPDATE_ORDINAL_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [RECIPE_STEPS_OPTIONS_UPDATE]: (state, action) => {
    return state.merge({
      options: action.options,
    });
  },
  [RECIPE_STEPS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function recipeSteps(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
